import React from 'react';

import { IssueCreateWarningDialogContainer } from './IssueCreateWarningDialogContextProvider.tsx';
import { IssueCreateSidePanelContainer } from './IssueCreateSidePanelContextProvider.tsx';

type SingleIssueCreateProvidersWrapperProps = {
	children?: React.ReactNode;
};
export const SingleIssueCreateProvidersWrapper: React.FC<
	SingleIssueCreateProvidersWrapperProps
> = ({ children }) => {
	return (
		<IssueCreateSidePanelContainer isGlobal>
			<IssueCreateWarningDialogContainer>{children}</IssueCreateWarningDialogContainer>
		</IssueCreateSidePanelContainer>
	);
};
